// Palette from the pottery brief. These are physical Three.js colors (not UI CSS).
export const CLAY_COLORS = [
  { id: "terracotta", label: "Terracotta", hex: "#C67C5C" },
  { id: "raw-clay", label: "Raw Clay", hex: "#E3DCD4" },
  { id: "porcelain", label: "Porcelain", hex: "#F7F7F5" },
  { id: "earthenware", label: "Earthenware", hex: "#8C6D4F" },
  { id: "midnight", label: "Midnight", hex: "#3A3532" },
] as const;

export type ClayColorId = (typeof CLAY_COLORS)[number]["id"];

export const WOOD_COLOR = "#5C4A3A";
export const SHADOW_COLOR = "#2A221E";
export const BG_COLOR = "#1A1816";

// Camera dolly range along Z
export const CAMERA_Z_MIN = 8; // close-up
export const CAMERA_Z_MAX = 25; // wide (matches brief's default "45°" framing)

// Speed
export const MAX_RPM = 240;

// Brush
export const BRUSH_MIN = 1;
export const BRUSH_MAX = 8;
export const BRUSH_DEFAULT = 3;

// Displacement canvas resolution
export const DISP_W_DESKTOP = 512;
export const DISP_H_DESKTOP = 256;
export const DISP_W_MOBILE = 256;
export const DISP_H_MOBILE = 128;

// Clay geometry resolution
export const RADIAL_DESKTOP = 128;
export const HEIGHT_DESKTOP = 64;
export const RADIAL_MOBILE = 64;
export const HEIGHT_MOBILE = 32;

// Clay dimensions (world units)
export const CLAY_RADIUS = 2.0;
export const CLAY_HEIGHT = 4.2;

// Displacement strength multiplier applied in the shader
export const DISPLACEMENT_STRENGTH = 1.4;

// Undo history cap
export const HISTORY_MAX = 20;

export type ToolId = "shape" | "pull" | "smooth" | "reset";